module.exports = __webpack_public_path__ + "img/band-5.edbf9ff6.png";